import { set } from 'cerebral/operators'
import { props, state } from 'cerebral/tags'
import addRestriction from '../actions/addRestriction'
import createSnackbar from 'modules/App/factories/createSnackbar'

const setMessage = () => {
  return function({ props, state }) {
    const { selectedFiles, tags: { showShared } } = state.get('media')
    const files = showShared ? selectedFiles : [props.id]

    files.forEach(id => {
      state.set(`media.files.${id}.restriction.message`, props.value)
    })

    return {
      restriction: state.get(`media.files.${files[0]}.restrictionType`)
    }
  }
}

export default [
  set(props`email`, state`media.tags.form.restriction.email.value`),
  set(props`message`, props`value`),
  setMessage(),
  addRestriction,
  createSnackbar({ key: 'bms.fieldSaved' }, 'success')
]



// WEBPACK FOOTER //
// ./src/modules/Media/chains/addRestrictionMessage.js